import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';

const ConsentModal = ({ onConsent, onDecline }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative bg-surface rounded-lg shadow-lg max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <Shield size={28} className="text-primary" />
          <h2 className="text-lg font-bold text-text">
            {t('consent.title')}
          </h2>
        </div>

        <div className="space-y-4">
          <p className="text-text">
            {t('consent.description')}
          </p>

          <ul className="list-disc list-inside text-sm text-text-muted space-y-1">
            <li>{t('consent.item_recordings')}</li>
            <li>{t('consent.item_transcripts')}</li>
            <li>{t('consent.item_scores')}</li>
          </ul>

          <p className="text-sm text-text-muted">
            {t('consent.who_access')}
          </p>

          <p className="text-sm text-text-muted">
            {t('consent.change_later')}
          </p>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onDecline}
            className="btn-secondary flex-1"
          >
            {t('consent.keep_private')}
          </button>
          <button
            onClick={onConsent}
            className="btn-primary flex-1"
          >
            {t('consent.share_data')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;
